module.exports = __webpack_public_path__ + "img/58_18.fa43f8f2.png";